module.exports = __webpack_public_path__ + "static/media/ROUSEEL MAHOU.89ba3913.png";